import type { SVGProps } from 'react';

export const DocumentFillSFSymbolMedium = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      height="1em"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 17.107 21.1441"
      fill="currentColor"
      {...props}
    >
      <g>
        {' '}
        <rect height="21.1441" opacity="0" width="17.107" x="0" y="0" />{' '}
        <path
          d="M3.17148 21.1379L13.5742 21.1379C15.6678 21.1379 16.7457 20.0422 16.7457 17.9406L16.7457 9.19823L9.44511 9.19823C8.22324 9.19823 7.62929 8.60429 7.62929 7.38066L7.62929 0L3.17148 0C1.08769 0 0 1.10371 0 3.20527L0 17.9406C0 20.0502 1.07968 21.1379 3.17148 21.1379ZM9.61855 7.7707L16.639 7.7707C16.5875 7.3334 16.2639 6.91113 15.7564 6.39395L10.4248 0.980467C9.93417 0.483593 9.50214 0.161719 9.05683 0.100391L9.05683 7.21699C9.05683 7.58613 9.2414 7.7707 9.61855 7.7707Z"
          fill="currentColor"
        />{' '}
      </g>
    </svg>
  );
};
